import React, { useMemo } from 'react'

import ChangedEmailMode from './ChangedEmailMode.module'
import SignupMode from './SignupMode.module'

export enum EmailVerifyMode {
  DEFAULT = 'default',
  CHANGE_EMAIL = 'change-email'
}

/**
 * @component
 * EmailVerified - Handles email verification display with different modes.
 * 
 * This component routes between different email verification flows based on URL parameters:
 * - DEFAULT mode: Shows signup completion message with auto-redirect
 * - CHANGE_EMAIL mode: Shows email change verification result
 * 
 * The component uses StatusPage for consistent design and supports both
 * regular email verification and email change verification flows.
 * 
 * @example
 * <EmailVerified />
 * 
 * @example
 * // For change email mode
 * <EmailVerified /> // with ?mode=change-email in URL
 * 
 * @returns {JSX.Element} The EmailVerified component
 */
const EmailVerified: React.FC = () => {
  const params = useMemo(() => new URLSearchParams(window.location.search), [])
  const emailVerifyMode = useMemo(() => params.has('mode') ? params.get('mode') : EmailVerifyMode.DEFAULT, [params])


  if (emailVerifyMode === EmailVerifyMode.DEFAULT) return <SignupMode />

  return <ChangedEmailMode />
}

export default EmailVerified
